import React from "react";
import { _goToBack } from "routers/helper";

import { Platform, View } from "react-native";
import { Input, Button, Header, InputLabel, AvatarPicker } from "components";
import { useForm, Controller } from "react-hook-form";

import { sizes, strings, patterns } from "assets/constants";
import { useRecoilValue } from "recoil";
import { authAtom } from "stores";
import { dataUrlToFile, mq, sn } from "utils";
import css from "styles";

import { useEditUser } from "clients/apis";

interface ProfileFormType {
  name?: string;
  mobile?: string;
  avatar?: AvatarType;
}

export default function Profile() {
  const auth = useRecoilValue(authAtom);

  const {
    control,
    getValues,
    handleSubmit,
    formState: { errors },
  } = useForm<ProfileFormType>({
    defaultValues: {
      name: auth?.name,
      mobile: auth?.mobile,
      avatar: { uri: auth?.avatar },
    },
  });

  const editUserMut = useEditUser();

  const _onSubmit = () => {
    const { name, mobile, avatar } = getValues();
    const { name: dName, mobile: dMobile, avatar: dAvatar } = auth;

    const avatarFile =
      avatar?.uri?.includes("data:image") &&
      dataUrlToFile(avatar?.uri, `profile${Date.now()}`);

    if (name === dName && mobile === dMobile && avatar?.uri === dAvatar) {
      _goToBack();
      return;
    }

    let postData = new FormData();
    postData.append("name", name);
    postData.append("mobile", mobile);

    if (Platform.OS === "web") {
      avatarFile && postData.append("avatar", avatarFile, avatarFile?.name);
    }

    if (Platform.OS === "android") {
      avatar?.uri !== auth?.avatar && postData.append("avatar", avatar as any);
    }

    editUserMut.mutate(postData);
  };

  return (
    <>
      <Header title={strings.user_info} />
      <View style={{ ...css.responsiveInputsListContainer }}>
        <View style={{ width: "100%" }}>
          <Controller
            control={control}
            name="avatar"
            render={({ field: { value, onChange } }) => (
              <AvatarPicker avatar={value} onChange={onChange} />
            )}
          />
        </View>

        <View style={css.responsiveInputContainer}>
          <InputLabel label={strings.name} />
          <Controller
            name="name"
            control={control}
            rules={{ required: { value: true, message: strings.fill_input } }}
            render={({ field: { onChange, value } }) => {
              return (
                <Input
                  value={value}
                  onChangeText={onChange}
                  placeholder={strings.insert_name}
                  icon={{ name: "user" }}
                  error={errors.name?.message as string}
                />
              );
            }}
          />
        </View>

        <View style={css.responsiveInputContainer}>
          <InputLabel label={strings.mobile} />
          <Controller
            name="mobile"
            control={control}
            rules={{
              required: { value: true, message: strings.fill_input },
              pattern: {
                value: patterns.mobile,
                message: strings.invalid_mobile,
              },
            }}
            render={({ field: { onChange, value } }) => {
              return (
                <Input
                  editable={false}
                  value={value}
                  onChangeText={onChange}
                  maxLength={11}
                  placeholder={strings.insert_mobile}
                  icon={{ name: "smartphone" }}
                  error={errors.mobile?.message as string}
                />
              );
            }}
          />
        </View>
      </View>
      <View style={css.cover} />
      <View
        style={{
          width: "100%",
          padding: sizes.space,
          maxWidth: sn("100%", "100%", 300, 300),
        }}
      >
        <Button
          style={{ marginTop: mq(20) }}
          loading={editUserMut.isLoading}
          title={{ value: strings.submit_info }}
          onPress={handleSubmit(_onSubmit)}
        />
      </View>
    </>
  );
}
